<mat-table
  [dataSource]="getDataSource(conversions)"
  data-test="scheme-table"
  [formGroup]="formGroup"
>
  <ng-container formArrayName="lines">
    <ng-container matColumnDef="liter">
      <mat-header-cell class="slim-column" *matHeaderCellDef>
        {{ 'settings.dosator-setting.product.liter' | translate }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__liter"
        [formGroupName]="i"
        class="slim-column"
      >
        <ng-container>
          <mat-form-field floatLabel="auto" subscriptSizing="dynamic" class="cell--input-field">
            <input
              matInput
              agrNumber
              [min]="0"
              [step]="0.01"
              data-test="settings.dosator-setting-product__liter_value"
              formControlName="liter"
            />
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="kilogram">
      <mat-header-cell class="slim-column" *matHeaderCellDef>
        {{ 'settings.dosator-setting.product.kilogram' | translate }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__kilogram"
        [formGroupName]="i"
        class="slim-column"
      >
        <ng-container>
          <mat-form-field floatLabel="auto" subscriptSizing="dynamic" class="cell--input-field">
            <input
              matInput
              agrNumber
              [min]="0"
              [step]="0.01"
              data-test="settings.dosator-setting-product__kilogram_value"
              formControlName="kilogram"
            />
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="kilogramPerLiter">
      <mat-header-cell class="slim-column" *matHeaderCellDef>
        {{ 'settings.dosator-setting.product.kilogramPerLiter' | translate }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__kilogramPerLiter"
        [formGroupName]="i"
        class="slim-column"
      >
        <ng-container>
          <mat-form-field class="cell--input-field" floatLabel="auto" subscriptSizing="dynamic">
            <input
              matInput
              agrNumber
              [min]="0"
              [step]="0.01"
              data-test="settings.dosator-setting-product__kilogramPerLiter_value"
              formControlName="kilogramPerLiter"
              readonly
            />{{calculateKilogramPerLiter(i)}}
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"> </mat-row>
  </ng-container>
</mat-table>

<div class="mat-button-row spacing--margin-top">
  <button
    mat-stroked-button
    color="primary"
    style="font-size: 12px"
    data-test="scheme-table_button-add-bottom"
    (click)="changeNumberOfLines('add-bottom')"
  >
    <mat-icon>add</mat-icon>
    <ng-container>{{ 'settings.dosator-setting.buttons.add-bottom' | translate }}</ng-container>
  </button>
  <button
    mat-stroked-button
    color="primary"
    style="font-size: 12px"
    data-test="scheme-table_button-remove-bottom"
    [disabled]="conversions?.length <= 1"
    (click)="changeNumberOfLines('remove-bottom')"
  >
    <mat-icon>remove</mat-icon>
    <ng-container>{{ 'settings.dosator-setting.buttons.remove-bottom' | translate }}</ng-container>
  </button>
</div>
